export class SipNotReadyError extends Error {
  code = "SIP_NOT_READY" as const;

  constructor(
    message = "No SIP invitation reached this browser. Your SIP registration may be stale — refresh the page and sign back in."
  ) {
    super(message);
    this.name = "SipNotReadyError";
  }
}

export const isSipNotReadyError = (error: unknown): error is SipNotReadyError =>
  error instanceof SipNotReadyError ||
  (error instanceof Error && error.name === "SipNotReadyError");

export const isRegisterInProgressError = (error: unknown): boolean =>
  error instanceof Error &&
  error.message.includes("REGISTER request already in progress");

export const isConnectAbortedError = (error: unknown): boolean =>
  error instanceof Error && error.message.includes("Connect aborted");
